import { fromStringToObject } from '@elab/core/utils/dynaForms/helpers';

export default function personalInformationDtoBuilder(data, dto = {}) {
    const fieldsData = Object.values(data);

    fieldsData.forEach(({ value, dtoFields }) => {
        if (!dtoFields || value === undefined || !dtoFields.length) return;

        dtoFields.forEach(dtoField => {
            fromStringToObject(dtoField, value, dto);
        });
    });

    return dto;
}
